<template>
  <div class="space-y-2">
    <p
      v-if="showLabel"
      class="text-xs font-semibold tracking-wide text-gray-400 uppercase">
      {{ label || 'Share Link' }}
    </p>
    <div class="flex gap-2">
      <!-- Copy Link Button -->
      <button
        class="group relative flex-1 flex items-center justify-center gap-2 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 overflow-hidden shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
        :class="[
          linkCopied
            ? 'bg-blue-600 text-white shadow-blue-600/30'
            : 'bg-gradient-to-br from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white'
        ]"
        @click="handleCopyLink">
        <!-- Animated background on hover -->
        <div
          v-if="!linkCopied"
          class="absolute inset-0 bg-gradient-to-br from-blue-400 to-blue-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>

        <!-- Button content -->
        <div class="flex relative z-10 gap-2 items-center">
          <fa-icon
            :icon="linkCopied ? 'check' : 'link'"
            class="text-base transition-transform duration-300"
            :class="linkCopied ? 'scale-110' : 'group-hover:rotate-12'" />
          <span>{{ linkCopied ? 'Copied!' : 'Copy Link' }}</span>
        </div>
      </button>

      <!-- WhatsApp Button -->
      <button
        class="group relative flex-1 flex items-center justify-center gap-2 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 overflow-hidden shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] bg-gradient-to-br from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white"
        @click="handleShareToWhatsApp">
        <!-- Animated background on hover -->
        <div
          class="absolute inset-0 bg-gradient-to-br from-green-300 to-green-400 opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>

        <!-- Button content -->
        <div class="flex relative z-10 gap-2 items-center">
          <fa-icon
            :icon="['fab', 'whatsapp']"
            class="text-lg transition-transform duration-300 group-hover:scale-110" />
          <span>{{ whatsappLabel || 'WhatsApp' }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useShareActions } from '@/use/useShareActions'

const props = defineProps({
  link: {
    type: String,
    default: null
  },
  whatsappMessage: {
    type: String,
    default: null
  },
  showLabel: {
    type: Boolean,
    default: true
  },
  label: {
    type: String,
    default: null
  },
  whatsappLabel: {
    type: String,
    default: null
  }
})

const { linkCopied, copyLink, shareToWhatsApp } = useShareActions()

const handleCopyLink = () => {
  copyLink(props.link)
}

const handleShareToWhatsApp = () => {
  shareToWhatsApp({
    link: props.link,
    message: props.whatsappMessage
  })
}
</script>
